export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const PROFILE_RESET = "PROFILE_RESET"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG"
export const GET_USER_INFO = "GET_USER_INFO"
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS"
export const GET_USER_INFO_ERROR = "GET_USER_INFO_ERROR"